import { render, staticRenderFns } from "./custom-name.vue?vue&type=template&id=66b0143b&scoped=true"
import script from "./custom-name.vue?vue&type=script&lang=ts"
export * from "./custom-name.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b0143b",
  null
  
)

export default component.exports